// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

	let fadeOptions = {
  "duration":   300,
  "delay":      5
};

export function storemenu_mouseOut(event) {
	//Add your code for this event here: 
	$w('#storemenu').hide("fade", fadeOptions);
}


export function menubuttonrzr_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picrzr').show ("fade", fadeOptions); 
		}
		

export function menubuttonrzr_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picrzr').hide("fade", fadeOptions);
}


export function menubuttonmotoequip_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picmotoequip').show ("fade", fadeOptions);
}

export function menubuttonmotoequip_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picmotoequip').hide("fade", fadeOptions);
}

export function menubuttonhydration_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#pichydration').show ("fade", fadeOptions);
}

export function menubuttonhydration_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#pichydration').hide("fade", fadeOptions);
}

export function menubuttonmach_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picmach').show ("fade", fadeOptions);
}

export function menubuttonmach_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picmach').hide("fade", fadeOptions);
}


export function menubuttongym_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picgym').show ("fade", fadeOptions);
}

export function menubuttongym_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picgym').hide("fade", fadeOptions);
}

export function menubuttonbackpack_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picbackpack').show ("fade", fadeOptions);
}

export function menubuttonbackpack_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here:
	$w('#picbackpack').hide("fade", fadeOptions); 
}

export function menubuttonbuis_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picbuis').show ("fade", fadeOptions);
}

export function menubuttonbuis_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picbuis').hide("fade", fadeOptions);
}

export function menubuttononbord_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#piconbord').show ("fade", fadeOptions);
}

export function menubuttononbord_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#piconbord').hide("fade", fadeOptions);
}

export function menubuttonrig_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picrig').show ("fade", fadeOptions);
}

export function menubuttonrig_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picrig').hide("fade", fadeOptions);
}

export function menubuttontrolly_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#pictrolly').show ("fade", fadeOptions);
}

export function menubuttontrolly_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#pictrolly').hide("fade", fadeOptions);
}

export function menubottonxix_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picxix').show ("fade", fadeOptions);
}

export function menubottonxix_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picxix').hide("fade", fadeOptions);
}

export function menubuttonfuse_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picfuse').show ("fade", fadeOptions);
}

export function menubuttonfuse_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picfuse').hide("fade", fadeOptions);
}

export function menubuttonalpha_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picalpha').show ("fade", fadeOptions);
}

export function menubuttonalpha_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picalpha').hide("fade", fadeOptions);
}

export function menubuttonaero_mouseIn(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picaero').show ("fade", fadeOptions);
}

export function menubuttonaero_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	$w('#picaero').hide("fade", fadeOptions);
}